import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import Select from 'react-select';
import { getRegionLayers, setRowInReducer, setInitialState } from '../../actions/SuperAdminActions';
import i18n from '../../i18n/i18n';
import immutable from 'seamless-immutable';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import AddRegionLayer from './AddRegionLayer';
const CheckboxTable = checkboxHOC(ReactTable);
export class RegionLayer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            add: this.props.add,
            edit: this.props.edit,
            showFilters: this.props.showFilters,
            selection: [],
            selectAll: false
        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.deleted === true) {
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getRegionLayers(wrapped.state);
            this.setState({
                selection: [],
                selectAll: false,
            })
            this.props.setInitialState('deleted');
        }
        if (nextProps.regionLayerPostingSuccess === true) {
            this.setState({
                selection: [],
                name: '',
                selectAll: false
            })
            this.props.handleClose();
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getRegionLayers(wrapped.state);
            this.props.setInitialState('regionLayerPostingSuccess');
        }
        this.setState({
            add: nextProps.add,
            showFilters: nextProps.showFilters,
        })
        if (nextProps.add == true && nextProps.edit == false) {
            this.props.setInitialState('regionLayerObj');
            this.setState({
                selection: [],
                name: '',
                selectAll: false
            })
        }
    }

    toggleSelection = (key, shift, row) => {
        let selection = [...this.state.selection];
        const keyIndex = selection.indexOf(key);
        if (keyIndex >= 0) {
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
        } else {
            selection.push(key);
        }
        this.setState({ selection }, function () {
            if (selection.length == 1) {
                let row1 = this.props.region_lejer.filter((rlg) => {
                    return rlg.id == selection;
                })
                this.props.setRowInReducer(row1[0], 'regionLayerObj');
            }
        });
        this.props.setSelection(selection, 'region_lejer');
    };

    toggleAll = () => {
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        if (selectAll) {
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => {
                selection.push(item._original.id);
            });
        }
        this.setState({ selectAll, selection });
        this.props.setSelection(selection, 'region_lejer');

    };

    isSelected = key => {
        return this.state.selection.includes(key);
    };

    render() {
        let content;
        const { toggleSelection, toggleAll, isSelected } = this;
        const { selectAll } = this.state;
        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return {
                        style: {
                            backgroundColor: selected ? "lightgreen" : "inherit"
                        }
                    };
                }
                return {};
            }
        };
        content =
            <div className="page">
                <CheckboxTable data={this.props.region_lejer}
                    columns={this.columns}
                    ref={r => (this.checkboxTable = r)}
                    keyField={'id'}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={25}
                    filterable={this.state.showFilters}
                    showPaginationTop
                    showPaginationBottom={false}
                    pages={this.props.regionLayerPages}
                    loading={this.props.regionLayerFetching}
                    manual
                    onFetchData={(state, instance) => this.props.getRegionLayers(state, instance)}
                    className="-striped -highlight"
                    previousText={i18n.t('Previous')}
                    nextText={i18n.t('Next')}
                    loadingText={i18n.t('Loading...')}
                    noDataText={i18n.t('No rows found')}
                    pageText={i18n.t('Page')}
                    ofText={i18n.t('of')}
                    rowsText={i18n.t('rows')}
                    {...checkboxProps}

                />
                {this.state.add && <AddRegionLayer add={this.state.add} edit={this.props.edit}
                    handleClose={this.props.handleClose} />}
            </div>


        return (
            <div>
                {content}
            </div >
        )
    }

    columns = [
        {
            Header: i18n.t('Title'),
            accessor: 'naziv',
        },
        {
            Header: i18n.t('Region layer group'),
            accessor: 'naziv_rlg',
        },
        {
            Header: i18n.t('Region'),
            accessor: 'naziv_regiona'
        },
        {
            Header: i18n.t('Layer'),
            accessor: 'id_lejer'
        },
        {
            Header: i18n.t('WMS Layer'),
            accessor: 'wms_layers'
        },
        {
            Header: i18n.t('Type'),
            accessor: 'tip'
        },
        {
            Header: i18n.t('Source'),
            accessor: 'izvor'
        },
        {
            Header: i18n.t('URL'),
            accessor: 'url'
        },
        {
            id: 'vidljivost',
            Header: i18n.t('Visibility'),
            accessor: d => d.pravi, // Custom value accessors!
            Cell: ({ value }) => value != 0 ? i18n.t('Yes') : i18n.t('No')
        },
    ];
};

function mapStateToProps(state) {
    return {
        region_lejer: state.superAdminReducer.region_lejer,
        regionLayerPages: state.superAdminReducer.regionLayerPages,
        regionLayerFetching: state.superAdminReducer.regionLayersGroupsFetching,
        regionLayerPostingSuccess: state.superAdminReducer.regionLayerPostingSuccess,
        deleted: state.superAdminReducer.deleted
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getRegionLayers: (state, instance) => dispatch(getRegionLayers(state, instance)),
        setRowInReducer: (row, name) => dispatch(setRowInReducer(row, name)),
        setInitialState: (component) => dispatch(setInitialState(component))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegionLayer)